<template>
  <a-card :bordered="false">
    <a-form class="m-form" :form="form">
      <a-row type="flex" justify="center" align="top" :gutter="16">
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
          <a-form-item label="NIK">
            <a-input
              autocomplete="off"
              v-decorator="[
                'nik',
                { rules: [{ required: true }], initialValue: profile.nik }
              ]"
            />
          </a-form-item>
          <a-form-item label="TLC">
            <a-input
              :disabled="mode === 'edit'"
              autocomplete="off"
              :maxlength="3"
              v-decorator="[
                'tlc',
                { rules: [{ required: true }], initialValue: profile.tlc }
              ]"
            />
          </a-form-item>
          <a-form-item label="Nama Lengkap">
            <a-input
              autocomplete="off"
              v-decorator="[
                'nama',
                { rules: [{ required: true }], initialValue: profile.nama }
              ]"
            />
          </a-form-item>
          <a-form-item label="No. Ktp">
            <a-input
              autocomplete="off"
              :maxlength="16"
              v-decorator="[
                'no_ktp',
                { rules: [{ required: true }], initialValue: profile.no_ktp }
              ]"
            />
          </a-form-item>
          <a-form-item label="Alamat">
            <a-textarea
              :rows="1"
              v-decorator="[
                'alamat',
                { rules: [{ required: true }], initialValue: profile.alamat }
              ]"
            />
          </a-form-item>
          <a-form-item label="No. Telp">
            <a-input
              autocomplete="off"
              v-decorator="[
                'noTelp',
                { rules: [{ required: false }], initialValue: profile.no_telp }
              ]"
            >
              <a-select
                slot="addonBefore"
                v-decorator="['noTelp_code', { initialValue: '62' }]"
                style="width: 70px"
              >
                <a-select-option key="62" value="62">+62</a-select-option>
                <a-select-option key="61" value="61">+61</a-select-option>
              </a-select>
            </a-input>
          </a-form-item>
          <a-form-item label="Tempat Lahir">
            <a-input
              autocomplete="off"
              v-decorator="[
                'tempat_lahir',
                {
                  rules: [{ required: true }],
                  initialValue: profile.tempat_lahir
                }
              ]"
            />
          </a-form-item>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
          <a-form-item label="Tanggal Lahir">
            <a-date-picker
              class="w-full"
              :format="getDefaultDateFormat"
              v-decorator="[
                'tgl_lahir',
                {
                  rules: [{ required: true }],
                  initialValue: profile.tanggal_lahir
                }
              ]"
            />
          </a-form-item>
          <a-form-item label="Jenis Kelamin">
            <a-select
              v-decorator="[
                'gender',
                { rules: [{ required: true }], initialValue: profile.gender }
              ]"
            >
              <a-select-option key="pria" value="laki-laki"
                >Laki - Laki</a-select-option
              >
              <a-select-option key="perempuan" value="perempuan"
                >Perempuan</a-select-option
              >
            </a-select>
          </a-form-item>
          <a-form-item label="Status Perkawinan">
            <a-select
              v-decorator="[
                'status_perkawinan',
                {
                  rules: [{ required: true }],
                  initialValue: profile.status_perkawinan
                }
              ]"
            >
              <a-select-option key="m" value="menikah">Menikah</a-select-option>
              <a-select-option key="bm" value="belum-menikah"
                >Belum Menikah</a-select-option
              >
              <a-select-option key="ch" value="cerai-hidup"
                >Cerai Hidup</a-select-option
              >
              <a-select-option key="cm" value="cerai-mati"
                >Cerai Mati</a-select-option
              >
            </a-select>
          </a-form-item>
          <a-form-item label="Agama">
            <a-select
              v-decorator="[
                'agama',
                { rules: [{ required: true }], initialValue: profile.agama }
              ]"
            >
              <a-select-option key="islam" value="islam">Islam</a-select-option>
              <a-select-option key="kristen protestan" value="Kristen protestan"
                >Kristen Protestan</a-select-option
              >
              <a-select-option key="katolik" value="katolik"
                >Katolik</a-select-option
              >
              <a-select-option key="hindu" value="hindu">Hindu</a-select-option>
              <a-select-option key="buddha" value="buddha"
                >Buddha</a-select-option
              >
              <a-select-option key="kong hu cu" value="kong hu cu"
                >Kong Hu Cu</a-select-option
              >
            </a-select>
          </a-form-item>
          <a-form-item label="email">
            <a-input
              autocomplete="off"
              v-decorator="[
                'email',
                {
                  rules: [
                    {
                      type: 'email',
                      message: 'The input is not valid E-mail!'
                    },
                    { required: false }
                  ],
                  initialValue: profile.email
                }
              ]"
            />
          </a-form-item>
          <a-form-item v-if="mode === 'create'" label="Foto Karyawan">
            <a-upload
              class="d-block"
              accept="image/*"
              :showUploadList="true"
              :fileList="fotoKaryawan"
              listType="picture"
              :beforeUpload="beforeUpload"
              v-decorator="[
                'foto',
                { rules: [{ required: true }] },
                { valuePropName: 'push' }
              ]"
            >
              <a-button>
                <a-icon type="upload" />&nbsp; Select Picture
              </a-button>
            </a-upload>
          </a-form-item>
          <a-form-item label="Tanggungan">
              <a-select
                v-decorator="[
                  'tanggungan',
                  {
                    rules: [{ required: true }],
                    initialValue: profile.tanggungan,
                  },
                ]"
              >
                <a-select-option v-for="(item, index) in getMaster.tanggungan" :key="index" :value="item.value">
                  {{item.text}}-{{item.status}}
                </a-select-option>
              </a-select>
            </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "profile",
  props: ["data", "mode"],
  data() {
    return {
      fotoKaryawan: [],
      profile: {}
    };
  },
  watch: {
    data() {
      this.profile = {
        agama: this.data.profile.agama,
        alamat: this.data.profile.alamat,
        email: this.data.profile.email,
        foto: this.data.profile.foto,
        nama: this.data.profile.nama,
        nik: this.data.profile.nik,
        no_ktp: this.data.profile.no_ktp,
        no_telp: this.data.profile.no_telp,
        status_perkawinan: this.data.profile.status_perkawinan,
        gender: this.data.profile.gender,
        tanggal_lahir: moment(
          this.data.profile.tanggal_lahir,
          this.getDefaultDateFormat
        ),
        tempat_lahir: this.data.profile.tempat_lahir,
        tlc: this.data.profile.tlc,
        tanggungan: this.data.profile.tanggungan,
      };
    }
  },
  computed: {
    ...mapGetters(["getDefaultDateFormat", "getMaster"])
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  methods: {
    moment,
    beforeUpload(file) {
      console.log(file);
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 2) {
        this.displayMessage("large-file");
      } else {
        this.fotoKaryawan = [file];
        return false;
      }
    },
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        const telpon = values.noTelp_code + values.noTelp;
        const dataValues = {
          ...values,
          foto: this.fotoKaryawan,
          telpon: telpon
        };

        Event.$emit("createKaryawan", dataValues);
      });
    }
  }
};
</script>

<style></style>
